import { Search } from 'lucide-react';

export interface AdminSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
}

/** Controlled search box -- the caller is expected to pass `value` through `useDebouncedValue` before using it in a query key, so every keystroke updates the visible input immediately but only debounced values trigger a refetch. */
export function AdminSearchInput({
  value,
  onChange,
  placeholder = 'Search…',
  label = 'Search',
}: AdminSearchInputProps) {
  return (
    <label className="relative flex items-center">
      <span className="sr-only">{label}</span>
      <Search className="pointer-events-none absolute left-3 h-4 w-4 text-gray-400" aria-hidden="true" />
      <input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="focus-visible:ring-brand w-full min-w-[200px] rounded-full border border-gray-200 py-1.5 pl-9 pr-3 text-sm focus-visible:outline-none focus-visible:ring-2"
      />
    </label>
  );
}
